export const UPDATE_ADMIN_PANEL_SETTINGS = "users/adminpanel/setting/update";
export const GET_KEY_WISE_SETTINGS = "users/adminpanel/setting/get";

// reuqest verification api
export const REQUEST_VERIFICATION_END_POINT =
  "users/adminpanel/setting/approval";

export const GET_ADMIN_PANEL_SETTINGS_CONFIG_API_ENDPOINT = "users/adminpanel";

export const UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL = "users/adminpanel/setting/listing/update";